import { render, staticRenderFns } from "./EmployeesListSimple.vue?vue&type=template&id=88742796&scoped=true&"
import script from "./EmployeesListSimple.vue?vue&type=script&setup=true&lang=js&"
export * from "./EmployeesListSimple.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./EmployeesListSimple.vue?vue&type=style&index=0&id=88742796&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88742796",
  null
  
)

export default component.exports